module.exports = __webpack_public_path__ + "img/1555939108.c9a8ef74.jpg";